import React from "react";
import { BarChart as RBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { getChartTheme } from "./chartTheme";

/** data: [{ name, value }] */
const BarChart = ({ data = [], theme = "light", color = "#3b82f6", height = 280, noDataLabel = "No data" }) => {
  const { grid, axis, tooltipStyle, labelStyle } = getChartTheme(theme);
  const gradientId = `barGradient-${color.replace("#", "")}`;

  if (!data.length) {
    return <ChartEmpty height={height} theme={theme} label={noDataLabel} />;
  }

  return (
    <ResponsiveContainer width="100%" height={height}>
      <RBarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={color} stopOpacity={0.95} />
            <stop offset="95%" stopColor={color} stopOpacity={0.55} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke={grid} vertical={false} />
        <XAxis dataKey="name" tick={{ fill: axis, fontSize: 11 }} axisLine={{ stroke: grid }} tickLine={false} />
        <YAxis tick={{ fill: axis, fontSize: 11 }} axisLine={false} tickLine={false} width={36} />
        <Tooltip contentStyle={tooltipStyle} labelStyle={labelStyle} cursor={{ fill: grid }} />
        <Bar dataKey="value" fill={`url(#${gradientId})`} radius={[8, 8, 0, 0]} maxBarSize={48} animationDuration={600} />
      </RBarChart>
    </ResponsiveContainer>
  );
};

export const ChartEmpty = ({ height = 280, theme = "light", label = "No data" }) => (
  <div style={{
    height, display: "flex", alignItems: "center", justifyContent: "center",
    color: theme === "dark" ? "rgba(255,255,255,0.4)" : "rgba(30,41,59,0.4)",
    fontSize: 13, fontWeight: 500,
  }}>
    {label}
  </div>
);

export default BarChart;
